import { render, staticRenderFns } from "./OnboardingSeeking.vue?vue&type=template&id=5b1e4ca8&"
import script from "./OnboardingSeeking.vue?vue&type=script&lang=js&"
export * from "./OnboardingSeeking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports